import httpService from "./httpService.js"

export const loginService = (data) => {
    return httpService("/admin_accounts/admin_login/", "post", data);
}

export const forgotPasswordService = (data) => {
    return httpService("/admin_accounts/admin_forgot_password/", "post", data);
}

export const logoutService = () => {
    return httpService("/admin_accounts/admin_logged_out/", "get");
}
